import React from "react";
import "../styles/StoreBadges.css";
import { trackEvent } from "../utils/analytics";
import { useLanguage } from "../context/Language";

import playEN from "../assets/images/app-stores-badges/playstore/google-play-badge-en.svg";
import playFR from "../assets/images/app-stores-badges/playstore/google-play-badge-fr.svg";
import playES from "../assets/images/app-stores-badges/playstore/google-play-badge-es.svg";
import playAR from "../assets/images/app-stores-badges/playstore/google-play-badge-ar.svg";
import playIT from "../assets/images/app-stores-badges/playstore/google-play-badge-it.svg";

import appleEN from "../assets/images/app-stores-badges/appstore/app-store-badge-en.svg";
import appleFR from "../assets/images/app-stores-badges/appstore/app-store-badge-fr.svg";
import appleES from "../assets/images/app-stores-badges/appstore/app-store-badge-es.svg";
import appleAR from "../assets/images/app-stores-badges/appstore/app-store-badge-ar.svg";
import appleIT from "../assets/images/app-stores-badges/appstore/app-store-badge-it.svg";

import huaweiEN from "../assets/images/app-stores-badges/appgallery/appgallery-badge-EN-BLACK.png";
import huaweiFR from "../assets/images/app-stores-badges/appgallery/appgallery-badge-FR-BLACK.svg";
import huaweiES from "../assets/images/app-stores-badges/appgallery/appgallery-badge-ES-BLACK.svg";
import huaweiAR from "../assets/images/app-stores-badges/appgallery/appgallery-badge-AR-BLACK.svg";
import huaweiIT from "../assets/images/app-stores-badges/appgallery/appgallery-badge-IT-BLACK.svg";

import galaxyEN from "../assets/images/app-stores-badges/galaxystore/galaxy-store-badge-en.png";
import galaxyFR from "../assets/images/app-stores-badges/galaxystore/galaxy-store-badge-fr.png";
import galaxyES from "../assets/images/app-stores-badges/galaxystore/galaxy-store-badge-es.png";
import galaxyAR from "../assets/images/app-stores-badges/galaxystore/galaxy-store-badge-ar.png";
import galaxyIT from "../assets/images/app-stores-badges/galaxystore/galaxy-store-badge-it.png";

// Each store goes live on its own schedule, so each URL is enabled separately.
// A badge with no URL is not rendered at all: a dead link is worse than nothing.
const APP_STORE_URL = ""; // TODO: App Store listing
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=ma.mabrook.app";
const APPGALLERY_URL = "https://appgallery.huawei.com/app/C118933891";
const GALAXY_STORE_URL =
  "https://apps.samsung.com/appquery/appDetail.as?appId=ma.mabrook.app&source=GBadge_01_9287420_tag";

const badges = {
  apple: {
    en: appleEN,
    fr: appleFR,
    es: appleES,
    ar: appleAR,
    it: appleIT,
  },
  play: { en: playEN, fr: playFR, es: playES, ar: playAR, it: playIT },
  huawei: {
    en: huaweiEN,
    fr: huaweiFR,
    es: huaweiES,
    ar: huaweiAR,
    it: huaweiIT,
  },
  galaxy: {
    en: galaxyEN,
    fr: galaxyFR,
    es: galaxyES,
    ar: galaxyAR,
    it: galaxyIT,
  },
};

const STORES = [
  {
    key: "apple",
    url: APP_STORE_URL,
    className: "store-badge-apple",
    alt: "Download on the App Store",
    event: "App Store",
  },
  {
    key: "play",
    url: PLAY_STORE_URL,
    className: "store-badge-google",
    alt: "Get it on Google Play",
    event: "Play Store",
  },
  {
    key: "huawei",
    url: APPGALLERY_URL,
    className: "store-badge-huawei",
    alt: "Explore it on AppGallery",
    event: "AppGallery",
  },
  {
    key: "galaxy",
    url: GALAXY_STORE_URL,
    className: "store-badge-galaxy",
    alt: "Available on Galaxy Store",
    event: "Galaxy Store",
  },
];

const StoreBadges = ({ className = "", location = "" }) => {
  const { language } = useLanguage();
  const lang = language?.value || "en";

  const live = STORES.filter((store) => store.url);
  if (!live.length) return null;

  return (
    <div className={`store-badges ${className}`}>
      {live.map((store) => (
        <a
          key={store.key}
          href={store.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`store-badge-link ${store.className}`}
          onClick={() =>
            trackEvent({ label: `${store.event} ${location}`.trim() })
          }
        >
          <img
            src={badges[store.key][lang] || badges[store.key].en}
            alt={store.alt}
            className="store-badge-img"
          />
        </a>
      ))}
    </div>
  );
};

export default StoreBadges;
